var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    [
      _c(
        "el-col",
        { staticStyle: { padding: "10px" }, attrs: { span: 24 } },
        [
          _c(
            "div",
            {
              staticStyle: {
                border: "4px solid #cccccc",
                "border-radius": "30px",
                padding: "20px"
              }
            },
            [
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c("span", { staticClass: "form-selection-title" }, [
                      _vm._v("Reservation Form")
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { staticStyle: { "margin-top": "15px" } },
                [
                  _c(
                    "el-col",
                    {
                      staticClass: "d-flex jc-center ac-center",
                      attrs: { span: 24 }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "text-dino text-w500 text-26 color-green"
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.listingDetails.apt) +
                              " / " +
                              _vm._s(_vm.listingDetails.address)
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    {
                      staticClass: "d-flex jc-center ac-center",
                      attrs: { span: 24 }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "text-dino text-w500 text-26 color-green"
                        },
                        [_vm._v(_vm._s(_vm.listingDetails.suburb))]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    {
                      staticClass: "d-flex jc-center ac-center",
                      attrs: { span: 24 }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "text-dino text-w400 text-22 color-green"
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.listingDetails.state) +
                              " " +
                              _vm._s(_vm.listingDetails.postcode)
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { staticStyle: { "margin-top": "10px" } },
                [
                  _c(
                    "el-col",
                    {
                      staticClass: "d-flex jc-center ac-center",
                      attrs: { span: 24 }
                    },
                    [
                      _c("el-divider", {
                        staticStyle: { padding: "0 5px" },
                        attrs: { direction: "horizontal" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  this.getOfferType() == "Select now"
                    ? _c(
                        "el-col",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "center"
                          },
                          attrs: { span: 24 }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "listing-price-state",
                              staticStyle: { "margin-top": "0" }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.listingDetails.price != 0
                                    ? "$" + _vm.listingDetails.price
                                    : ""
                                )
                              )
                            ]
                          )
                        ]
                      )
                    : _c(
                        "el-col",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "center",
                            "align-items": "center"
                          },
                          attrs: { span: 24 }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "listing-price-state",
                              staticStyle: { "margin-top": "0" }
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.listingDetails.price != 0
                                      ? "$" + _vm.listingDetails.price
                                      : ""
                                  ) +
                                  "\n                  " +
                                  _vm._s(
                                    _vm.listingDetails.maxPrice != 0
                                      ? " - $" + _vm.listingDetails.maxPrice
                                      : ""
                                  ) +
                                  "\n                "
                              )
                            ]
                          )
                        ]
                      ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "center",
                        "align-items": "center",
                        "margin-top": "10px"
                      },
                      attrs: { span: 24 }
                    },
                    [
                      _c("span", { staticClass: "chip-gray" }, [
                        _vm._v(_vm._s(_vm.listingDetails.proertyType))
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _vm.$route.query.type == "2"
                    ? _c(
                        "el-col",
                        {
                          staticStyle: {
                            "margin-top": "20px",
                            "line-height": "1.5"
                          },
                          attrs: { span: 24 }
                        },
                        [
                          _c(
                            "el-row",
                            { staticStyle: { "margin-top": "20px" } },
                            [
                              _c(
                                "el-col",
                                {
                                  staticClass: "d-flex jc-center",
                                  attrs: { span: 24 }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-18 text-w400 text-dino text-center"
                                    },
                                    [
                                      _vm._v(
                                        "\n                      1. Complete the online form with all details of the purchaser and\n                      conveyancer or solicitor.\n                    "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                {
                                  staticClass: "d-flex jc-center",
                                  attrs: { span: 24 }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-18 text-w400 text-dino text-center"
                                    },
                                    [
                                      _vm._v(
                                        "\n                      Please complete all details carefully as\n                      they will be used to prepare the contract of sale and enable\n                    "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                {
                                  staticClass: "d-flex jc-center",
                                  attrs: { span: 24 }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-18 text-w400 text-dino text-center"
                                    },
                                    [
                                      _vm._v(
                                        "\n                      the Agent to contact you to progress the sale.\n                    "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                {
                                  staticClass: "d-flex jc-center",
                                  attrs: { span: 24 }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-18 text-w400 text-dino text-center"
                                    },
                                    [
                                      _vm._v(
                                        "\n                      2. Click “Pay and Submit Reservation” to pay the $1,000\n                      reservation fee securely online.\n                    "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                {
                                  staticClass: "d-flex jc-center",
                                  attrs: { span: 24 }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        " text-18 text-w400 text-dino text-center"
                                    },
                                    [
                                      _vm._v(
                                        "\n                      3. Once your reservation is received, the Agent will contact you\n                      directly to prepare the contract of sale and take you through next\n                      steps.\n                    "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                {
                                  staticClass: "d-flex jc-center",
                                  attrs: { span: 24 }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-18 text-w400 text-dino text-center"
                                    },
                                    [
                                      _vm._v(
                                        "\n                      4. Upon the expiry of the 7-day reservation period, your $1,000\n                      reservation fee will be refunded to your original method of\n                      payment.\n                    "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "reservationForm",
                      attrs: {
                        model: _vm.reservationForm,
                        rules: _vm.reservationFormRules
                      }
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            {
                              staticStyle: { "margin-top": "10px" },
                              attrs: { span: 24 }
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "title-reservation-section" },
                                [_vm._v("Purchaser Details")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.reservationForm.allPurchaser, function(
                            purchaser,
                            index
                          ) {
                            return _c(
                              "div",
                              { key: index },
                              [
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      {
                                        staticStyle: { "margin-top": "10px" },
                                        attrs: { span: 24 }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "title-purchaser-section"
                                          },
                                          [
                                            _vm._v(
                                              "Purchaser #" +
                                                _vm._s(purchaser.purchaserId)
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-row",
                                  {
                                    staticStyle: { "margin-top": "20px" },
                                    attrs: { gutter: 20 }
                                  },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "allPurchaser." +
                                                index +
                                                ".title"
                                            }
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: {
                                                  display: "inline"
                                                },
                                                attrs: { placeholder: "Title" },
                                                model: {
                                                  value: purchaser.title,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      purchaser,
                                                      "title",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "purchaser.title"
                                                }
                                              },
                                              _vm._l(_vm.titles, function(t) {
                                                return _c("el-option", {
                                                  key: t.id,
                                                  attrs: {
                                                    label: t.title,
                                                    value: t.title
                                                  }
                                                })
                                              }),
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 18 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "allPurchaser." +
                                                index +
                                                ".firstName"
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                placeholder: "First name"
                                              },
                                              model: {
                                                value: purchaser.firstName,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    purchaser,
                                                    "firstName",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "purchaser.firstName"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 24 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                placeholder: "Middle names"
                                              },
                                              model: {
                                                value: purchaser.middleName,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    purchaser,
                                                    "middleName",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "purchaser.middleName"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 24 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "allPurchaser." +
                                                index +
                                                ".surName"
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: { placeholder: "Surname" },
                                              model: {
                                                value: purchaser.surName,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    purchaser,
                                                    "surName",
                                                    $$v
                                                  )
                                                },
                                                expression: "purchaser.surName"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 24 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "allPurchaser." +
                                                index +
                                                ".address"
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: { placeholder: "Address" },
                                              model: {
                                                value: purchaser.address,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    purchaser,
                                                    "address",
                                                    $$v
                                                  )
                                                },
                                                expression: "purchaser.address"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 24 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "allPurchaser." +
                                                index +
                                                ".suburb"
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: { placeholder: "Suburb" },
                                              model: {
                                                value: purchaser.suburb,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    purchaser,
                                                    "suburb",
                                                    $$v
                                                  )
                                                },
                                                expression: "purchaser.suburb"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 24 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "allPurchaser." +
                                                index +
                                                ".state"
                                            }
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: {
                                                  display: "inline"
                                                },
                                                attrs: { placeholder: "State" },
                                                model: {
                                                  value: purchaser.state,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      purchaser,
                                                      "state",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "purchaser.state"
                                                }
                                              },
                                              _vm._l(
                                                _vm.listingStates,
                                                function(state) {
                                                  return _c("el-option", {
                                                    key: state.id,
                                                    attrs: {
                                                      label: state.stateName,
                                                      value: state.stateName
                                                    }
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 24 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "allPurchaser." +
                                                index +
                                                ".postcode"
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                placeholder: "Postcode"
                                              },
                                              model: {
                                                value: purchaser.postcode,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    purchaser,
                                                    "postcode",
                                                    $$v
                                                  )
                                                },
                                                expression: "purchaser.postcode"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 24 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          [
                                            _c("el-input", {
                                              attrs: { placeholder: "Phone" },
                                              model: {
                                                value: purchaser.mobile,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    purchaser,
                                                    "mobile",
                                                    $$v
                                                  )
                                                },
                                                expression: "purchaser.mobile"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 24 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop:
                                                "allPurchaser." +
                                                index +
                                                ".email"
                                            }
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: { placeholder: "Email" },
                                              model: {
                                                value: purchaser.email,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    purchaser,
                                                    "email",
                                                    $$v
                                                  )
                                                },
                                                expression: "purchaser.email"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "center"
                              },
                              attrs: { span: 24 }
                            },
                            [
                              _c(
                                "el-form-item",
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: {
                                        "justify-content": "center",
                                        "border-radius": "0",
                                        "border-bottom": "1px solid #003333",
                                        "padding-bottom": "2px",
                                        color: "#003333"
                                      },
                                      attrs: { type: "text" },
                                      on: { click: _vm.addAnotherPurchaser }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    Add another purchaser's details\n                  "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "Purchasing entity" },
                                    model: {
                                      value: _vm.purchasingEntity,
                                      callback: function($$v) {
                                        _vm.purchasingEntity = $$v
                                      },
                                      expression: "purchasingEntity"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            {
                              staticStyle: { "margin-top": "8px" },
                              attrs: { span: 24 }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "para-form-selection",
                                  staticStyle: {
                                    font: "400 18px DINosaur-a, sans-serif"
                                  }
                                },
                                [
                                  _vm._v(
                                    "Only complete if you are purchasing outside of your personal\n                name"
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.$route.query.type == "1"
                        ? _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                {
                                  staticStyle: { "margin-top": "20px" },
                                  attrs: { span: 24 }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "title-reservation-section"
                                    },
                                    [_vm._v("Make an Offer")]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$route.query.type == "1"
                        ? _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                {
                                  staticStyle: { "margin-top": "8px" },
                                  attrs: { span: 24 }
                                },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { prop: "payment.offerAmount" } },
                                    [
                                      _c("el-input", {
                                        attrs: { placeholder: "Make an offer" },
                                        model: {
                                          value:
                                            _vm.reservationForm.payment
                                              .offerAmount,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.reservationForm.payment,
                                              "offerAmount",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "reservationForm.payment.offerAmount"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            {
                              staticStyle: { "margin-top": "20px" },
                              attrs: { span: 24 }
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "title-reservation-section" },
                                [_vm._v("Purchaser's Conveyancer/Solicitor")]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            {
                              staticStyle: { "margin-top": "18px" },
                              attrs: { span: 24 }
                            },
                            [
                              _c(
                                "el-form-item",
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "align-items": "center",
                                        width: "100%"
                                      },
                                      on: {
                                        change: _vm.conveyancerCheckboxToggle
                                      },
                                      model: {
                                        value: _vm.checked,
                                        callback: function($$v) {
                                          _vm.checked = $$v
                                        },
                                        expression: "checked"
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "color-green text-w400 text-dino text-18 text-wrap"
                                        },
                                        [
                                          _vm._v(
                                            "Please check the box if you would like to nominate a different conveyancer or solicitor and complete the\n                    fields below"
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "First Name" },
                                    model: {
                                      value:
                                        _vm.reservationForm.legal.firstName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.reservationForm.legal,
                                          "firstName",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "reservationForm.legal.firstName"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "Last Name" },
                                    model: {
                                      value: _vm.reservationForm.legal.lastName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.reservationForm.legal,
                                          "lastName",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "reservationForm.legal.lastName"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "Address" },
                                    model: {
                                      value: _vm.reservationForm.legal.address,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.reservationForm.legal,
                                          "address",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "reservationForm.legal.address"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "Suburb" },
                                    model: {
                                      value: _vm.reservationForm.legal.suburb,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.reservationForm.legal,
                                          "suburb",
                                          $$v
                                        )
                                      },
                                      expression: "reservationForm.legal.suburb"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { display: "inline" },
                                      attrs: { placeholder: "State" },
                                      model: {
                                        value: _vm.reservationForm.legal.state,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.reservationForm.legal,
                                            "state",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "reservationForm.legal.state"
                                      }
                                    },
                                    _vm._l(_vm.listingStates, function(state) {
                                      return _c("el-option", {
                                        key: state.id,
                                        attrs: {
                                          label: state.stateName,
                                          value: state.stateName
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "Postcode" },
                                    model: {
                                      value: _vm.reservationForm.legal.postcode,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.reservationForm.legal,
                                          "postcode",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "reservationForm.legal.postcode"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "Landline" },
                                    model: {
                                      value: _vm.reservationForm.legal.phone,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.reservationForm.legal,
                                          "phone",
                                          $$v
                                        )
                                      },
                                      expression: "reservationForm.legal.phone"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "Landline" },
                                    model: {
                                      value: _vm.reservationForm.legal.mobile,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.reservationForm.legal,
                                          "mobile",
                                          $$v
                                        )
                                      },
                                      expression: "reservationForm.legal.mobile"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "Email" },
                                    model: {
                                      value: _vm.reservationForm.legal.email,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.reservationForm.legal,
                                          "email",
                                          $$v
                                        )
                                      },
                                      expression: "reservationForm.legal.email"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "Email" },
                                    model: {
                                      value:
                                        _vm.reservationForm.legal.companyName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.reservationForm.legal,
                                          "companyName",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "reservationForm.legal.companyName"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "align-items": "center",
                                        width: "100%"
                                      },
                                      model: {
                                        value: _vm.reservationForm.cashDeposit,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.reservationForm,
                                            "cashDeposit",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "reservationForm.cashDeposit"
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "color-green text-w400 text-dino text-18 text-wrap"
                                        },
                                        [
                                          _vm._v(
                                            "Would you like information on a deposit bond to secure this property without a cash deposit?\n                    "
                                          ),
                                          _c("em", [
                                            _vm._v(
                                              "By ticking this box, you consent to your contact details being shared with our deposit bond partner, Downsizer."
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 24 } }, [
                            _c(
                              "span",
                              { staticClass: "title-reservation-section" },
                              [_vm._v("Agent's Details")]
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            {
                              staticStyle: { "margin-top": "18px" },
                              attrs: { span: 24 }
                            },
                            [
                              _c(
                                "el-form-item",
                                [
                                  _c(
                                    "el-col",
                                    {
                                      staticClass: "agent-details",
                                      attrs: { span: 10 }
                                    },
                                    [_c("span", [_vm._v("Company Name")])]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-col",
                                    {
                                      staticClass: "agent-details-right",
                                      attrs: { span: 14 }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.listingDetails.companyName)
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                [
                                  _c(
                                    "el-col",
                                    {
                                      staticClass: "agent-details",
                                      attrs: { span: 10 }
                                    },
                                    [_c("span", [_vm._v("Contact Person")])]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-col",
                                    {
                                      staticClass: "agent-details-right",
                                      attrs: { span: 14 }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.listingDetails.agentFirstName1
                                          ) +
                                            "\n                  " +
                                            _vm._s(
                                              _vm.listingDetails.agentLastName1
                                            )
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                [
                                  _c(
                                    "el-col",
                                    {
                                      staticClass: "agent-details",
                                      attrs: { span: 10 }
                                    },
                                    [_c("span", [_vm._v("Address")])]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-col",
                                    {
                                      staticClass: "agent-details-right",
                                      attrs: { span: 14 }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.listingDetails.companyAddress
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                [
                                  _c(
                                    "el-col",
                                    {
                                      staticClass: "agent-details",
                                      attrs: { span: 10 }
                                    },
                                    [_c("span", [_vm._v("Phone Number")])]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-col",
                                    {
                                      staticClass: "agent-details-right",
                                      attrs: { span: 14 }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.reservationForm.agent
                                              .phoneNumber
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                [
                                  _c(
                                    "el-col",
                                    {
                                      staticClass: "agent-details",
                                      attrs: { span: 10 }
                                    },
                                    [_c("span", [_vm._v("Email")])]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-col",
                                    {
                                      staticClass: "agent-details-right",
                                      staticStyle: {
                                        "word-wrap": "break-word",
                                        "word-break": "break-word"
                                      },
                                      attrs: { span: 14 }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.listingDetails.companyEmail
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.listingDetails.price != 0 &&
                      _vm.$route.query.type == "2"
                        ? _c(
                            "el-row",
                            [
                              _c("el-col", {
                                ref: "checkout",
                                attrs: { id: "checkout", span: 24 }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            {
                              staticStyle: {
                                "margin-top": "20px",
                                display: "flex",
                                "justify-content": "center"
                              },
                              attrs: { offset: 4, span: 16 }
                            },
                            [
                              _vm.$route.query.type == "1"
                                ? _c(
                                    "el-button",
                                    {
                                      staticClass: "btn-pay-submit",
                                      on: { click: _vm.submitReservation }
                                    },
                                    [_c("span", [_vm._v("Submit Offer")])]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.$route.query.type == "2" &&
                              !_vm.checkoutDisplayed
                                ? _c(
                                    "el-button",
                                    {
                                      staticClass: "btn-pay-submit",
                                      on: { click: _vm.submitReservation }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v("Pay and Submit Reservation")
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            {
                              staticStyle: { "margin-top": "20px" },
                              attrs: { span: 24 }
                            },
                            [
                              _vm.$route.query.type == "2"
                                ? _c(
                                    "span",
                                    { staticClass: "para-form-selection" },
                                    [
                                      _vm._v(
                                        "Congratulations on your property reservation. Your real estate\n                agent will be in touch shortly."
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.$route.query.type == "1"
                                ? _c(
                                    "span",
                                    { staticClass: "para-form-selection" },
                                    [
                                      _vm._v(
                                        "Congratulations. Your real estate agent will be in touch\n                shortly."
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-624055c8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-624055c8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservation/reservationFormSection.vue
// module id = null
// module chunks = 